import {OffersPage} from './components';

export default OffersPage;
